export class ReOpenMessage {
    title?: string;
    content?: string;
    operation?: string;
}